module.exports = __webpack_public_path__ + "img/arrow-up.adf584d1.svg";